import { checkApp, getAppVersion, checkBrowser, isWaveWebview, isPayWebview } from "./browser.mjs";
import * as browser from "./browser.mjs";
import { getOsInfo } from "./device.mjs";
import * as device from "./device.mjs";
import * as version from "./version.mjs";
import { getUserAgentString } from "./utils.mjs";
function getUserAgent(userAgent) {
  const agent = getUserAgentString(userAgent);
  return {
    app: {
      type: checkApp(agent),
      version: getAppVersion(agent)
    },
    browser: checkBrowser(agent),
    isWave: isWaveWebview(agent),
    isPayWeb: isPayWebview(agent),
    os: getOsInfo(agent)
  };
}
export {
  browser as Browser,
  device as Device,
  version as Version,
  getUserAgent
};
